import './Tooltip.scss';

import cn from 'classnames';
import React, { useState } from 'react';

import { TooltipDefaultProps, TooltipPropTypes } from './Tooltip.proptypes';

const Tooltip = ({
  children,
  className,
  context,
  disabled,
  message,
  position,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  const handleMouseEnter = () => {
    if (message && !disabled) {
      setIsVisible(true);
    }
  };

  const handleMouseLeave = () => {
    setIsVisible(false);
  };

  return (
    <div
      className={cn('tooltip', `tooltip--${position}`, className)}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      data-qa-position={position}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...(context ? { 'data-qa-id': context } : { 'data-qa-id': 'tooltip' })}
    >
      {children}
      {isVisible && (
        <div className="tooltip__container" data-qa-id="tooltip-container">
          {message}
        </div>
      )}
    </div>
  );
};

Tooltip.defaultProps = {
  ...TooltipDefaultProps,
};

Tooltip.propTypes = {
  ...TooltipPropTypes,
};

export default Tooltip;
